import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AthleteBiographyRoutingModule } from './athlete-biography-routing.module';
import { BoostrapAthleteBiographyComponent } from './boostrap-athlete-biography/boostrap-athlete-biography.component';
import { CommonPageComponentsModule } from 'src/app/common-page-components/common-page-components.module';
import { ServicesModule } from 'world-archery-lib';
import { FiltersAthleteBiographyService } from './services/filters-athlete-biography.service';
import { ComponentsModule } from 'world-archery-lib';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AthleteBiographyInsightsComponent } from './components/athlete-insights/athlete-insights.component';
import { AthleteMedalsComponent } from './components/athlete-medals/athlete-medals.component';
import { AthleteOlympicPanelComponent } from './components/athlete-olympic-panel/athlete-olympic-panel.component';
import { SortOlympicPanelPipe } from './pipes/sort-olympic-panel.pipe';

@NgModule({
  declarations: [BoostrapAthleteBiographyComponent, AthleteBiographyInsightsComponent, AthleteMedalsComponent, AthleteOlympicPanelComponent, SortOlympicPanelPipe],
  imports: [
    CommonModule,
    AthleteBiographyRoutingModule,
    CommonPageComponentsModule,
    ComponentsModule,
    SlickCarouselModule
  ],
  providers: [FiltersAthleteBiographyService]
})
export class AthleteBiographyModule { }
